import { Box, Button, Divider, Switch } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link } from "react-router";
import DialogModal from "../DialogModal/DialogModal";
import React, { useState } from "react";
import cookieBannerStyle from "./cookieBannerStyle";
import { useCookieConsent } from "../../provider/CookieConsent/CookieConsentProvider";

type CookieModalProps = {
  open: boolean;
  setIsConfigureOpen: (open: boolean) => void;
  isSelectionMade: boolean;
  setIsSelectionMade: (isSelectionMade: boolean) => void;
};

const CookieModal = ({ open, setIsConfigureOpen, isSelectionMade, setIsSelectionMade }: CookieModalProps) => {
  const { saveConsent, hasConsent } = useCookieConsent();
  const [analyticsChecked, setAnalyticsChecked] = useState(hasConsent("analytics"));

  const saveSelection = () => {
    saveConsent({
      consentType: "configured",
      config: {
        analytics: analyticsChecked,
      },
    });
  };

  return (
    <DialogModal
      open={open && !isSelectionMade}
      onClose={() => setIsConfigureOpen(false)}
      title={"Cookie-Einstellungen anpassen"}
      maxWidth={"md"}
      responsive={true}
      actions={<ModalActions setAnalyticsChecked={setAnalyticsChecked} setIsSelectionMade={setIsSelectionMade} saveSelection={saveSelection} />}
    >
      <Box sx={cookieBannerStyle.modalContent}>
        <p>Wir verwenden Cookies und ähnliche Tools (zusammen "Cookies") für folgende Zwecke:</p>
        <strong>Essenziell</strong>
        <Grid container sx={{
          alignItems: "center"
        }}>
          <Grid size={11}>
            <p>
              Diese Cookies sind erforderlich, um unsere Website und Services bereitzustellen und können nicht deaktiviert werden. Sie werden in der Regel als
              Reaktion auf Ihre Aktionen auf der Website festgelegt, z. B. die Festlegung Ihrer Datenschutzeinstellungen, die Anmeldung oder das Ausfüllen von
              Formularen sowie den Bezahlprozess.
            </p>
          </Grid>
          <Grid size={1}>
            <Switch color="primary" defaultChecked disabled />
          </Grid>
        </Grid>
        <Divider />
        <br />
        <strong>Analyse & Funktionen</strong>
        <Grid container sx={{
          alignItems: "center"
        }}>
          <Grid size={11}>
            <p>
              Technologien dieser Kategorie ermöglichen es uns, die Nutzung der Website zu analysieren, um deren Leistung zu messen und zu verbessern. Zudem
              werden sie verwendet, um erweiterte Funktionen und Personalisierungen bereitzustellen, die das Nutzererlebnis optimieren und eine hohe
              Datenqualität bei der Interaktion mit unseren Diensten sicherstellen.
            </p>
          </Grid>
          <Grid size={1}>
            <Switch color="primary" checked={analyticsChecked} onChange={({ target }) => setAnalyticsChecked(target.checked)} />
          </Grid>
        </Grid>
        <Divider />
        <br />
        <p>
          Das Blockieren einiger Arten von Cookies kann sich auf Ihre Erfahrung auf unseren Websites auswirken. Um mehr über die auf unserer Homepage genutzten
          Cookies zu erfahren und Ihre Cookie-Einstellungen jederzeit zu ändern besuchen Sie bitte unsere{" "}
          <Link to={"/cookierichtlinie"} target="__blank">
            Cookierichtlinie
          </Link>
          .
        </p>
      </Box>
    </DialogModal>
  );
};

const ModalActions = ({
  setIsSelectionMade,
  saveSelection,
  setAnalyticsChecked = () => {},
}: {
  setIsSelectionMade: (isSelectionMade: boolean) => void;
  saveSelection: Function;
  setAnalyticsChecked: (analyticsChecked: boolean) => void;
}) => {
  const { denyAll, allowAll } = useCookieConsent();

  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          md: 4,
          xs: 12
        }}>
        <Button
          fullWidth
          onClick={() => {
            setIsSelectionMade(true);
            setAnalyticsChecked(false);
            denyAll();
          }}
          color={"primary"}
        >
          Ablehnen
        </Button>
      </Grid>
      <Grid
        size={{
          md: 4,
          xs: 12
        }}>
        <Button
          fullWidth
          onClick={() => {
            setIsSelectionMade(true);
            saveSelection();
          }}
          color={"primary"}
        >
          Auswahl speichern
        </Button>
      </Grid>
      <Grid
        size={{
          md: 4,
          xs: 12
        }}>
        <Button
          fullWidth
          onClick={() => {
            setIsSelectionMade(true);
            setAnalyticsChecked(true);
            allowAll();
          }}
          variant={"contained"}
          color={"primary"}
        >
          Alle Akzeptieren
        </Button>
      </Grid>
    </Grid>
  );
};

export default CookieModal;
